// Human-friendly date formatting. Parses "YYYY-MM-DD" without timezone drift.
// Months use the 3-letter abbreviation (Sep, Aug, …): first letter capitalized.
const MONTHS = [
    "Jan", "Feb", "Mar", "Apr", "May", "Jun",
    "Jul", "Aug", "Sep", "Oct", "Nov", "Dec",
];

export function formatDate(iso) {
    if (!iso) return "";
    const m = /^(\d{4})-(\d{1,2})-(\d{1,2})/.exec(String(iso).trim());
    if (!m) return iso;
    const [, y, mo, d] = m;
    const idx = Number(mo) - 1;
    if (idx < 0 || idx > 11) return iso;
    return `${MONTHS[idx]} ${Number(d)}, ${y}`;
}

export function formatDateRange(start, end) {
    const s = formatDate(start);
    if (end && end !== start) return `${s} → ${formatDate(end)}`;
    return s;
}

// Today's date as a LOCAL "YYYY-MM-DD" string. Using the browser's local date
// (not UTC) so an event only becomes "past" the day AFTER it ends — not the
// same evening for users in timezones behind UTC.
export function todayLocalISO() {
    const d = new Date();
    return `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, "0")}-${String(d.getDate()).padStart(2, "0")}`;
}

// Format optional start/end time display labels (e.g. "1:00 PM"–"3:00 PM").
export function formatTimeRange(start, end) {
    const s = (start || "").trim();
    const e = (end || "").trim();
    if (s && e) return `${s} – ${e}`;
    return s || e || "";
}

const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];const MONTHS_SHORT = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

// Compact weekday + date for a per-day row, e.g. "Fri · Aug 14".
export function formatDayShort(iso) {
    const m = /^(\d{4})-(\d{1,2})-(\d{1,2})/.exec(String(iso || "").trim());
    if (!m) return iso || "";
    const [, y, mo, d] = m;
    const wd = new Date(Date.UTC(+y, +mo - 1, +d)).getUTCDay();
    return `${WEEKDAYS[wd]} · ${MONTHS_SHORT[+mo - 1]} ${+d}`;
}
